export default __webpack_public_path__ + "images/e2aecb06c86770781f7cb67225ec8f51.svg";